<template>
  <div>
    <div @click="bread">
      <header-child ref="headerss" />
      <breadcrumb-child :title="title" :name="name" :href="href" />
    </div>
    <!-- 订单 -->
    <div class="container" v-if="orderDetails">
      <el-row :gutter="0" class="oerder-top">
        <el-col :span="8" :offset="3" class="order-card">
          <el-row :gutter="0">
            <el-col :span="8" :offset="0" class="card-img">
              <img src="@/assets/images/order_icon_amount.png" />
            </el-col>
            <el-col :span="16" :offset="0" class="card-text">
              <span>Сколько заказа</span>
              <p>{{ order_count }}</p>
            </el-col>
          </el-row>
        </el-col>
        <el-col :span="8" :offset="2" class="order-card">
          <el-row :gutter="0">
            <el-col :span="8" :offset="0" class="card-img">
              <img src="@/assets/images/order_icon_price.png" />
            </el-col>
            <el-col :span="16" :offset="0" class="card-text">
              <span>Cумма заказа</span>
              <p>{{ order_sum }}</p>
            </el-col>
          </el-row>
        </el-col>
      </el-row>

      <el-tabs v-model="activeName" @tab-click="handleClick">
        <!-- 全部 -->
        <el-tab-pane label="Заказы" name="first">
          <el-row :gutter="0" v-if="list.length > 0">
            <el-col :span="5" :offset="0" class="table-head-first"
              >Номер заказ</el-col
            >
            <el-col :span="4" :offset="0" class="table-head">Имя</el-col>
            <el-col :span="3" :offset="0" class="table-head">Количество</el-col>
            <el-col :span="4" :offset="0" class="table-head">Cумма</el-col>
            <el-col :span="3" :offset="0" class="table-head"
              >Статус заказа</el-col
            >
            <el-col :span="5" :offset="0" class="table-head"
              >действующий</el-col
            >
          </el-row>
        </el-tab-pane>
        <!-- 确定 -->
        <el-tab-pane label="Подтвержденный" name="second">
          <el-row :gutter="0" v-if="list.length > 0">
            <el-col :span="5" :offset="0" class="table-head-first"
              >Номер заказ</el-col
            >
            <el-col :span="4" :offset="0" class="table-head">Имя</el-col>
            <el-col :span="3" :offset="0" class="table-head">Количество</el-col>
            <el-col :span="4" :offset="0" class="table-head">Cумма</el-col>
            <el-col :span="3" :offset="0" class="table-head"
              >Статус заказа</el-col
            >
            <el-col :span="5" :offset="0" class="table-head"
              >действующий</el-col
            >
          </el-row>
        </el-tab-pane>
        <!-- 撤销 -->
        <el-tab-pane label="Отмена" name="third">
          <el-row :gutter="0" v-if="list.length > 0">
            <el-col :span="5" :offset="0" class="table-head-first"
              >Номер заказ</el-col
            >
            <el-col :span="4" :offset="0" class="table-head">Имя</el-col>
            <el-col :span="3" :offset="0" class="table-head">Количество</el-col>
            <el-col :span="4" :offset="0" class="table-head">Cумма</el-col>
            <el-col :span="3" :offset="0" class="table-head"
              >Статус заказа</el-col
            >
            <el-col :span="5" :offset="0" class="table-head"
              >действующий</el-col
            >
          </el-row>
        </el-tab-pane>
      </el-tabs>

      <div
        class="orderDetails"
        v-for="(item, index) in list"
        :key="index"
        @click="getdetails(item)"
      >
        <div class="orderDetails-first">
          <sapn class="span">{{ date(item.create_time) }}</sapn>
          <span class="span1">Подробности заказа</span>
        </div>
        <div class="orderDetails-content">
          <span class="orderNumber highTravel">{{ item.order_sn }}</span>
          <div class="div1">
            <span class="name highTravel">{{ item.name }}</span>
            <span class="sum highTravel"
              >Всего {{ item.total_package }} штук</span
            >
            <span class="money highTravel"
              >{{ calculateThePrice(parseFloat(item.total_amount)) }}p</span
            >
            <img
              src="../../assets/images/order_icon_sure.png"
              class="orderStatus"
              alt=""
              v-if="item.o_status == 0"
            />
            <img
              src="../../assets/images/order_icon_cancel.png"
              class="orderStatus"
              alt=""
              v-if="item.o_status == 1"
            />
            <img
              src="../../assets/images/order_img_pending.png"
              alt=""
              class="orderStatus"
              v-if="item.o_status == 2"
            />
            <div
              style="display: inline-block"
              class="operating"
              v-if="item.o_status == 0 || item.o_status == 2"
            >
              <div class="button" @click.stop="copy(item)">Копировать</div>
              <div class="button1" @click.stop="revoke(item)">Отмена</div>
            </div>
            <div style="display: inline-block" class="operating" v-else>
              <div class="button" @click.stop="copy(item)">Копировать</div>
              <div class="button2" @click.stop="revoke(item)">
                Восстановление
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="pagination">
        <el-pagination
          v-if="list.length != 0"
          background
          layout="prev, pager, next"
          :total="Number(this.order_count)"
          :page-size="10"
          :current-page="this.p"
          :pager-count="9"
          @prev-click="addp"
          @next-click="reducep"
          @current-change="changep"
        >
        </el-pagination>
      </div>
    </div>
    <div v-else>
      <div class="revoke">
        <p class="revoke1">Статус заказа:{{ type[listDetails.o_status] }}</p>
        <div class="btn">
          <div class="button" @click="copyDetails">Копировать</div>
          <div
            class="button2"
            v-if="listDetails.o_status == 1"
            @click="revokeDetails"
          >
            Восстановление
          </div>
          <!-- v-if="listDetails.o_status == 0" -->
          <div v-else class="button1" @click="revokeDetails">Отмена</div>
        </div>
      </div>
      <div class="orderdata">
        <p class="p2">Информация о заказе</p>
        <p class="p2">
          <span class="yangshi">Дата заказ：</span
          >{{ date(listDetails.create_time1) }}
        </p>
        <p>
          <span class="yangshi">Номер заказ：</span>{{ listDetails.order_sn }}
        </p>
        <p style="font-weight: 400">
          <span class="yangshi">Имя：</span>
          {{ listDetails.name }}
        </p>
        <p><span class="yangshi">Примечаний：</span>{{ listDetails.memo }}</p>
        <p>
          <span class="yangshi">Статус заказа：</span
          >{{ type[listDetails.o_status] }}
        </p>
      </div>
      <div class="commodityNavigation">
        <span>товар</span>
        <span>Цена </span>
        <span>Количество</span>
        <span>Сумму</span>
        <span>Примечания</span>
      </div>
      <div class="orderList">
        <!-- <el-row :gutter="20">
        <el-col :span="6"><div class="grid-content bg-purple"></div></el-col>
        <el-col :span="6"><div class="grid-content bg-purple"></div></el-col>
        <el-col :span="6"><div class="grid-content bg-purple"></div></el-col>
        <el-col :span="6"><div class="grid-content bg-purple"></div></el-col>
      </el-row> -->
        <img
          src="../../assets/images/orderdetail_img_watermask.png"
          class="image"
          alt=""
          v-if="listDetails.o_status == 1"
        />
        <div
          class="orderList-content"
          v-for="(item, index) in orderList"
          :key="index"
        >
          <div class="content-first">{{ item.order_num }}</div>
          <div style="display: flex; align-items: center">
            <div class="demo-image__preview" v-if="o_status == 1">
              <el-image
                style="width: 100px; height: 100px"
                :src="item.graffiti_img ? item.graffiti_img : item.thumb"
                :preview-src-list="srcList"
              >
              </el-image>
            </div>
            <div v-else>
              <img
                style="width: 100px; height: 100px"
                :src="item.graffiti_img ? item.graffiti_img : item.thumb"
                :preview-src-list="srcList"
                @click="graffitiPopUpWindow(item, index)"
              />
            </div>
            <span class="description">{{ item.name }}</span>
            <span class="price">{{ parseFloat(item.price) }}p</span>
            <span class="sum">{{ item.quantity }} × {{ item.packages }}</span>
            <span class="price-sum"
              >{{ calculateThePrice(parseFloat(item.sub_total)) }}p</span
            >
            <!-- <textarea >{{}}</textarea> -->
            <textarea
              class="note"
              cols="15"
              rows="5"
              readonly
              v-model="item.desc"
            ></textarea>
          </div>
        </div>
      </div>
      <div
        v-if="orderList.length != 0"
        class="buy"
        :style="
          orderList.length != 0 ? '' : 'position: fixed;left:0;bottom: 0;'
        "
      >
        <div class="content">
          <input class="note" v-model="memo" disabled="disabled" />
          <span :class="total > 30000 ? 'total_2' : 'total'"
            >Виды：{{ orderList.length }}</span
          >
          <div class="discount" v-if="total < 30000">
            <span class="totals">Итого：</span>
            <span class="money">{{ calculateThePrice(total) }}p</span>
          </div>
          <div class="discount" v-else>
            <p><span>Сумму ：</span> {{ calculateThePrice(total) }}p</p>
            <p class="margin" v-if="total < 80000">
              <span>-3%：</span>{{ calculateThePrice(total * 0.03) }}p
            </p>
            <p class="margin" v-else-if="total < 150000">
              <span>-6%：</span>{{ calculateThePrice(total * 0.06) }}p
            </p>
            <p class="margin" v-else-if="total > 15000">
              <span>-8%：</span>{{ calculateThePrice(total * 0.08) }}p
            </p>
            <p class="heji" v-if="total < 80000">
              <span>Итого：</span>{{ calculateThePrice(total * 0.97) }}p
            </p>
            <p class="heji" v-else-if="total < 150000">
              <span>Итого：</span>{{ calculateThePrice(total * 0.94) }}p
            </p>
            <p class="heji" v-else-if="total > 15000">
              <span>Итого：</span>{{ calculateThePrice(total * 0.92) }}p
            </p>
          </div>
        </div>
      </div>
      <!-- <div class="aaa">
        <div class="end" :style="listDetails.discount == 0 ? 'padding-top:20px;' : ''">
          <p class="total" v-if="listDetails.discount != 0">
            итого:<span style="color: #666">{{ listDetails.total_price }}</span>
          </p>
          <p class="total" v-if="listDetails.discount != 0">
            -{{ listDetails.discount }}%:<span style="color: #666">{{ listDetails.discount_amount }}</span>
          </p>
          <div class="end-content">
            <span class="span1">всего {{ listDetails.total_quantity }}шт</span>
            <span
              >итого:<span class="sapn-money">{{ listDetails.total_amount }}</span></span
            >
          </div>
        </div>
      </div> -->
    </div>
    <el-dialog
      v-if="graffiti && o_status == 2 && ordershow"
      :visible.sync="graffiti"
      width="636px"
      :before-close="handleClose"
      :closeOnClickModal="false"
    >
      <div class="canvas-container">
        <!-- v-if="orderList[commodity].images.length != 1" -->
        <!-- <span
          class="position"
          :style="
            subscriptIndex != 0
              ? 'background: #FFFFFF;color: #848484; transition: all .2s;'
              : ''
          "
        ></span> -->

        <!-- <el-carousel :interval="5000" @arrow="!load ? 'always' : 'none'" :autoplay="false" @change="subscript" :initial-index="subscriptIndex"> -->
        <!-- <el-carousel-item
            v-for="(item, index) in orderList[commodity].images"
            :key="index"
          > -->
        <div
          v-loading="load"
          v-if="index == 0"
          class="aoligei"
          ref="aoligei"
          element-loading-background="rgba(255, 255, 255, 1)"
        ></div>
        <img v-if="index > 0" :src="item" alt="" />
        <!-- </el-carousel-item> -->
        <!-- </el-carousel> -->
      </div>

      <graffiti
        ref="graffiti"
        :imgPath="orderList[commodity]"
        :subscriptIndex="subscriptIndex"
        :graffiti="load"
        :status="status"
        :item_ids="item_ids"
      />
    </el-dialog>
  </div>
</template>

<script>
import headerChild from "../../components/Header";
import breadcrumbChild from "../../components/Breadcrumb";
import Graffiti from "../../components/Graffiti";
import { num, calculatingTime } from "../../api/method";
export default {
  components: { headerChild, breadcrumbChild, Graffiti },
  data() {
    return {
      subscriptIndex: 0,
      breadcrumbItem: [{ title: "", href: "" }],
      orderDetails: true,
      activeName: "first",
      list: [], //订单列表
      dataList: [], // 处理订单列表的数据
      listDetails: [], // 订单详情列表
      type: ["покупку", "Отмена", "покупку"], //订单状态
      orderList: [], //订单详情商品列表
      index: 0, //标题下标
      order_id: "", //订单详情id
      o_status: "", // 订单状态
      order_count: "", //订单总数
      order_sum: "", //订单总额
      num: Number,
      title: "",
      name: "",
      p: 1,
      memo: "",
      graffiti: false,
      load: false,
      commodity: null,
      doodle: null,
      imgUrl: {},
      total: null,
      url: [],
      srcList: [],
      item_ids: "",
      status: "",
      ordershow: false,
    };
  },
  created() {
    this.getorderList(1);
    this.href = "/orderIndex";
  },
  mounted() {},
  methods: {
    date(num) {
      return calculatingTime(num);
    },
    /**
     * 计算千分位
     */
    calculateThePrice(str) {
      // console.log(str.toString());
      return num(str);
    },
    // 订单详情撤销和还原
    revokeDetails() {
      if (this.o_status == 0) {
        this.ordershow = true;
        this.o_status = parseInt(this.o_status) + 1;
      } else if (this.o_status == 2) {
        this.o_status = this.o_status - 1;
        this.ordershow = true;
      } else {
        this.o_status = parseInt(this.o_status) + 1;
      }
      let data = {
        token: localStorage.getItem("token"),
        order_id: this.order_id,
        o_status: this.o_status,
      };
      this.api.setStatus(data).then((res) => {
        // console.log(res);
        // this.getorderList();
        // this.handleClick(this.index);
        let data = {
          token: localStorage.getItem("token"),
          order_id: this.order_id,
        };
        this.api.info(data).then((res) => {
          // console.log(res);
          this.listDetails = res.data;
          this.total = parseFloat(res.data.total_price);
          this.orderList = res.data.order_item;
          this.o_status = res.data.o_status;
          this.order_id = res.data.id;
          this.item_ids = res.data.item_ids;
          this.orderList.forEach((item) => {
            this.srcList.push(
              item.graffiti_img ? item.graffiti_img : item.thumb
            );
            console.log(item);
            // let obj = [];
          });
          if (this.listDetails.memo == "") {
            this.listDetails.memo = "Нет";
          }
        });
      });
    },
    subscript(i) {
      // console.log(i);
      this.subscriptIndex = i;
    },
    loads() {
      this.load = false;

      // console.log(66666666);
    },
    operationalData(val) {
      this.orderList[this.commodity].graffiti_img = val;
      this.$forceUpdate();
      console.log(val);
    },
    graffitiPopUpWindow(item, index) {
      console.log(item);
      this.graffiti = true;
      this.load = true;
      this.status = true;
      this.$nextTick(() => {
        try {
          this.$refs.graffiti.initialization();
        } catch (error) {
          console.log("不是待定状态");
        }
      });

      // console.log(item.images);
      // if (item.images.length == 2) {
      //   console.log(666666);
      //   // var box = document.getElementsByClassName("el-carousel__arrow")[0];
      //   // box.remove();
      // }
      this.graffitiGoods = item;
      this.graffitiGoodsIndex = index;
      this.commodity = index;
      // this.imgUrl = item.thumb;
      // console.log(item);
      // console.log(item.thumb);
      this.$forceUpdate();
      // this.time = setTimeout(() => {
      //   if (this.load) {
      //     this.$message.error("Перезарядка перегружена");
      //     this.graffiti = false;
      //     clearTimeout(time);
      //   }
      // }, 15000);
    },
    handleClose(done) {
      done();
      // clearTimeout(this.time);
      this.load = true;
      this.doodle = new Date().getTime();
      this.imgUrl = null;
      let ele = document.getElementById("canvas");
      if (ele) {
        ele.remove();
      }
      console.log(this.graffitiGoods);
    },

    //订单详情复制
    copyDetails() {
      let data = {
        token: localStorage.getItem("token"),
        order_id: this.order_id,
      };
      this.api.orderCopy(data).then((res) => {
        console.log(res);
        this.$refs.headerss.doCount();
        this.Toast(res);
      });
    },
    addp() {
      this.p = this.p - 1;
      console.log(this.p);
      if (this.index == 1) {
        this.getordernormal();
        // 撤销
      } else if (this.index == 2) {
        this.getorderrevoke();
      } else {
        // 全部
        this.getorderList();
      }
    },
    reducep() {
      this.p = this.p + 1;
      console.log(this.p);
      if (this.index == 1) {
        this.getordernormal();
        // 撤销
      } else if (this.index == 2) {
        this.getorderrevoke();
      } else {
        // 全部
        this.getorderList();
      }
    },
    changep(e) {
      this.p = e;
      if (this.index == 1) {
        this.getordernormal();
        // 撤销
      } else if (this.index == 2) {
        this.getorderrevoke();
      } else {
        // 全部
        this.getorderList();
      }
    },
    // 全部
    getorderList() {
      // this.list = [];
      console.log(this.p);
      let data = {
        token: localStorage.getItem("token"),
        p: this.p,
        o_status: -1,
      };
      this.api.Order(data).then((res) => {
        // console.log(res);
        this.list = res.data.list;
        this.order_count = res.data.order_count;
        this.order_sum = res.data.order_sum;
      });
    },
    // 正常
    getordernormal() {
      let data = {
        token: localStorage.getItem("token"),
        p: this.p,
        o_status: 0,
      };
      this.api.Order(data).then((res) => {
        console.log(res);
        this.list = [];
        this.dataList = res.data.list;
        this.order_count = res.data.order_count;
        for (let i = 0; i < this.dataList.length; i++) {
          if (this.dataList[i].o_status == 0) {
            this.list.push(this.dataList[i]);
          }
        }
        // console.log(this.list, "index==1");
      });
    },
    getorderrevoke() {
      let data = {
        token: localStorage.getItem("token"),
        p: this.p,
        o_status: 1,
      };
      this.api.Order(data).then((res) => {
        console.log(res);
        this.order_count = res.data.order_count;
        this.list = [];
        this.dataList = res.data.list;
        // console.log(this.dataList);
        for (let i = 0; i < this.dataList.length; i++) {
          if (this.dataList[i].o_status == 1) {
            this.list.push(this.dataList[i]);
          }
        }
        console.log(this.list);
        // console.log(this.list, "index == 2");
      });
    },
    handleClick(tab, event, p) {
      if (tab.index != undefined) {
        this.index = tab.index;
      }
      this.p = 1;
      // this.list = [];
      // 正常
      if (this.index == 1) {
        this.getordernormal();
        // 撤销
      } else if (this.index == 2) {
        this.getorderrevoke();
      } else {
        // 全部
        this.getorderList();
      }
    },

    bread() {
      this.orderDetails = true;
      this.title = "";
      this.name = "";
      this.href = "";
      this.srcList = [];
    },
    //订单详情
    getdetails(key) {
      if (key.o_status != 1) {
        this.ordershow = true;
      }
      this.orderDetails = false;
      let data = {
        token: localStorage.getItem("token"),
        order_id: key.id,
      };
      this.api.info(data).then((res) => {
        console.log(res);
        this.title = "Исторические заказы ";
        this.name = "детали заказа";
        this.href = "/orderIndex";
        this.listDetails = res.data;
        this.orderList = res.data.order_item;
        this.total = parseFloat(res.data.total_price);
        this.memo = res.data.memo;
        this.o_status = res.data.o_status;
        this.item_ids = res.data.item_ids;
        this.order_id = res.data.id;
        this.orderList.forEach((item) => {
          this.srcList.push(item.graffiti_img ? item.graffiti_img : item.thumb);
          console.log(item);
          item.graffiti_img = item.graffiti_img
            ? item.graffiti_img +
              "?imageMogr2/format/heif?imageMogr2/thumbnail/636x"
            : item.thumb + "?imageMogr2/format/heif?imageMogr2/thumbnail/636x";
        });
        if (this.listDetails.memo == "") {
          this.listDetails.memo = "Нет";
        }
      });
    },
    //复制
    copy(key) {
      // console.log(key.id == undefined);
      console.log(key);
      if (key.id == undefined) {
        let data = {
          token: localStorage.getItem("token"),
          order_id: this.listDetails.id,
        };
        this.api.orderCopy(data).then((res) => {
          // console.log(res);
          this.$refs.headerss.doCount();
          this.Toast(res);
        });
      } else {
        let data = {
          token: localStorage.getItem("token"),
          order_id: key.id || this.listDetails.id,
        };
        this.api.orderCopy(data).then((res) => {
          this.$refs.headerss.doCount();
          // console.log(res);
          this.Toast(res);
        });
      }
    },
    //还原 撤销
    revoke(key) {
      // console.log(key);
      if (key.id == undefined) {
        let numstatus;
        if (this.listDetails.o_status == 0) {
          numstatus = parseInt(this.listDetails.o_status) + 1;
        } else if (this.o_status == 2) {
          numstatus = parseInt(this.listDetails.o_status) - 1;
        } else {
          numstatus = parseInt(this.listDetails.o_status) + 1;
        }
        // if (this.listDetails.o_status == 0) {
        //   numstatus = this.listDetails.o_status + 1;
        // } else {
        //    numstatus = this.listDetails.o_status + 1;
        // }
        let data = {
          token: localStorage.getItem("token"),
          order_id: this.listDetails.id,
          o_status: numstatus,
        };
        this.api.setStatus(data).then((res) => {
          console.log(res);
          this.getorderList();
          this.handleClick(this.index);
          // this.getdetails(key);
        });
      } else {
        let numstatus;
        if (key.o_status == 0) {
          numstatus = parseInt(key.o_status) + 1;
        } else if (key.o_status == 2) {
          numstatus = key.o_status - 1;
        } else {
          numstatus = parseInt(key.o_status) + 1;
        }
        // if (key.o_status == 0) {
        //   numstatus = key.o_status + 1;
        // } else {
        //   numstatus = key.o_status - 1;
        // }
        let data = {
          token: localStorage.getItem("token"),
          order_id: key.id,
          o_status: numstatus,
        };
        this.api.setStatus(data).then((res) => {
          console.log(res);
          // location.reload();
          // console.log(this.index);
          this.handleClick(this.index);
          // this.getdetails(key);
        });
      }
    },
  },
};
</script>

<style scoped lang="less">
.yangshi {
  min-width: 120px;
  text-align: right;
  display: inline-block;
}
.buy {
  // position: relative;
  width: 100%;
  height: 80px;
  margin-top: 20px;
  .content {
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    width: 1200px;
    // position: relative;
    margin: 0 auto;
    height: 80px;
    background: #f6f6f6;
    border: 1px solid #e6e6e6;
    opacity: 1;
    // box-shadow: 1px -1px 5px #888888;
    // padding: 12px 0 12px 20px;
    padding-left: 20px;
    .notes {
      height: 19px;
      font-size: 14px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      vertical-align: middle;
      color: #333333;
      opacity: 1;
    }

    .note {
      margin-top: 20px;
      resize: none;
      width: 400px;
      vertical-align: top;
      height: 48px;
      background: #f6f6f6;
      border: none;
      opacity: 1;
      padding: 5px;
      margin-right: 306px;
    }
    textarea {
      border: none;
      resize: none;
      /* 去除选中后的边框 */
      outline: none;
    }
    textarea:focus {
      outline: none !important;
      border: 1px solid edc18a;
      border-color: #edc18a;
    }
    .total_2 {
      height: 21px;
      font-size: 16px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #333333;
      opacity: 1;
      margin-right: 73px;
      vertical-align: top;
      display: inline-block;
      margin-top: 50px;
    }
    .total {
      height: 21px;
      font-size: 16px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #333333;
      opacity: 1;
      margin-right: 73px;
      vertical-align: top;
      display: inline-block;
      margin-top: 33.5px;
    }
    .totals {
      width: 48px;
      height: 21px;
      font-size: 16px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      line-height: 20px;
      color: #333333;
      vertical-align: top;
      display: inline-block;
      margin-top: 28.5px;
      margin-right: 8px;
      opacity: 1;
    }
    .money {
      height: 21px;
      font-size: 16px;
      font-family: Microsoft YaHei;
      font-weight: bold;
      line-height: 20px;
      display: inline-block;
      margin-top: 28.5px;
      color: #ff3939;
      vertical-align: top;
      opacity: 1;
    }
    .discount {
      display: inline-block;
      height: 100%;
      width: 200px;
      padding: 8px 0;
      position: absolute;
      right: 0;
      p {
        // text-align: center;
        height: 16px;
        font-size: 12px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        line-height: 20px;
        color: #666666;
        opacity: 1;
        span {
          display: inline-block;
          text-align: right;
          width: 60px;
          height: 16px;
          font-size: 12px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          line-height: 20px;
          color: #999999;
          opacity: 1;
        }
      }
      .margin {
        margin: 5px 0;
      }
      .heji {
        width: 400px;
        margin-left: -10px;
        height: 21px;
        font-size: 16px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        line-height: 20px;
        color: #ff3939;
        opacity: 1;
        span {
          height: 21px;
          font-size: 16px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          line-height: 20px;
          color: #333333;
          opacity: 1;
        }
      }
    }
    .buys {
      display: inline-block;
      position: absolute;
      cursor: pointer;
      right: 0;
      top: -1px;
      width: 144px;
      height: 80px;
      background: #edc18a;
      opacity: 1;
      font-size: 18px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      line-height: 74px;
      text-align: center;
      color: #ffffff;
      opacity: 1;
    }
  }
}
/deep/.el-image {
  position: relative;
  display: inline-block;
  overflow: hidden;
  margin-left: 20px;
  width: 100px;
  height: 100px;
}
/deep/.el-dialog__body {
  padding-top: 0;
  padding-bottom: 92px;
  position: relative;
  .canvas-container {
    width: 636px;
    height: 636px;
    opacity: 1;
    display: inline-block;
    position: relative;
    // text-align: center;
    .position {
      text-align: center;
      display: inline-block;
      position: absolute;
      left: 0;
      right: 0;
      margin: 0 auto;
      bottom: 12px;
      width: 68px;
      height: 26px;
      background: #ff3939;
      opacity: 0.74;
      border-radius: 18px;
      z-index: 3;
      font-family: PingFang SC;
      font-weight: 400;
      line-height: 26px;
      color: #ffffff;
      transition: all 0.2s;
    }
  }
  .information {
    display: inline-block;
    width: 365px;
    height: 200px;
    vertical-align: top;
    padding-top: 20px;
    padding-left: 18px;
    .introduction {
      height: 86px;
      display: inline-block;
      font-size: 14px;
      font-family: PingFang SC;
      font-weight: 400;
      line-height: 22px;
      color: #333333;
      opacity: 1;
    }
    p {
      height: 22px;
      font-size: 16px;
      font-family: PingFang SC;
      font-weight: 400;
      line-height: 22px;
      color: #333333;
      opacity: 1;
      input {
        padding: 0 12px;
        width: 69px;
        height: 22px;
        background: #f5f5f5;
        opacity: 1;
        border: none;
        font-family: PingFang SC;
        font-weight: bold;
        line-height: 22px;
        color: #333333;
        opacity: 1;
      }
    }
    .join {
      margin-top: 55px;
      margin-left: 82px;
      width: 232px;
      height: 50px;
      background: #edc18a;
      opacity: 1;
      border-radius: 6px;
      border: none;
      font-size: 16px;
      font-family: PingFang SC;
      font-weight: bold;
      line-height: 22px;
      color: #ffffff;
      opacity: 1;
    }
    .favorable {
      margin-top: 15px;
      p {
        height: 19px;
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        line-height: 19px;
        color: #333333;
        opacity: 1;
        margin-bottom: 6px;
        span {
          font-weight: 400;
          color: #ff3939;
        }
      }
    }
    .note {
      background: #f8f8f8;
      padding: 7px;
      width: 365px;
      margin-bottom: 53px;
      img {
        width: 14px;
        height: 14px;
        vertical-align: top;
        margin-top: 2px;
        margin-right: 3px;
      }
      textarea {
        width: 330px;
        height: 163px;
        background: #f8f8f8;
        opacity: 1;
        border: none !important;
        resize: none;
        // padding: 7px;
        outline: none;
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        line-height: 19px;
        color: #333333;
      }
    }
  }
}
/deep/.aoligei {
  height: 636px;
}
/deep/.el-dialog__header {
  display: none;
}
/deep/.el-dialog__body {
  padding: 0;
  width: 636px;
  height: 686px;
}
/deep/.el-pagination.is-background .btn-next,
.el-pagination.is-background .btn-prev,
.el-pagination.is-background .el-pager li {
  margin: 0 5px;
  background-color: #f4f4f5;
  // color: #606266;
  min-width: 30px;
  padding: 0 6px;
  border-radius: 2px;
}
/deep/.el-pagination.is-background .btn-prev {
  margin: 0 5px;
  background-color: #f4f4f5;
  // color: #606266;
  min-width: 30px;
  padding: 0 6px;
  border-radius: 2px;
}
/deep/.el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #edc18a !important;
  color: #fff !important;
  border: none !important;
}
/deep/.el-pagination.is-background .el-pager li:not(.disabled):hover {
  color: #edc18a;
}
/deep/.el-tabs__item {
  color: #666666;
  width: 180px;
  height: 50px;
  text-align: center;
  font-size: 18px;
  padding: 0;
}
/deep/.el-tabs__item.is-active {
  color: #edc18a;
}
/deep/.el-tabs__active-bar {
  background-color: #edc18a;
}
/deep/.el-tabs__nav-wrap::after {
  height: 1px;
  background-color: #e6e6e6;
}
.oerder-top {
  margin: 30px 0 40px;
}
.order-card {
  height: 120px;
  background: linear-gradient(180deg, #f6d3a8 0%, #efb972 100%);
  opacity: 1;
  border-radius: 6px;
  .card-img {
    text-align: center;
    height: 120px;
    img {
      display: inline-block;
      width: 72px;
      height: 72px;
      margin-top: 24px;
      margin-left: 30px;
    }
  }
  .card-text {
    height: 120px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    color: #fff;
    padding-left: 20px;
    span {
      font-size: 14px;
    }
    p {
      font-size: 24px;
      line-height: 40px;
      font-weight: bold;
    }
  }
}
.table-head-first {
  padding-left: 20px;
}
.table-head {
  text-align: center;
}
.orderDetails {
  width: 1200px;
  margin-top: 20px;
  .orderDetails-first:hover {
    cursor: pointer;
  }
  .orderDetails-first {
    background: #f6f6f6;
    width: 1200px;
    height: 32px;
    .span,
    .span1 {
      display: inline-block;
      line-height: 32px;
      color: #999;
      font-size: 12px;
      width: 580px;
    }
    .span {
      text-align: left;
      margin-left: 20px;
    }
    .span1 {
      margin-right: 20px;
      text-align: right;
    }
  }
  .orderDetails-content {
    font-size: 14px;
    padding: 7px 20px;
    color: #333;
    height: 62px;
    border: 1px solid #f6f6f6;
    // .highTravel {
    //   display: inline-block;
    //   // text-align: cente
    // }
    .orderNumber {
      display: inline-block;
      max-width: 181px;
      min-width: 190px;
      // line-height: 62px;
    }

    .div1 {
      margin-left: 120px;
      display: inline-block;
      // justify-content: flex-start;
    }
    .name {
      display: inline-block;
      width: 150px;
    }
    .orderStatus {
      width: 48px;
      height: 48px;
      // margin-left: 120px;
      vertical-align: middle;
    }
    .money {
      width: 175px;
      display: inline-block;
      // margin-left: 118px;
      color: #ff3939;
      font-weight: bold;
      // min-width: 65px;
      // margin-left: -20px;
    }
    .sum {
      display: inline-block;
      width: 190px;
      // margin-left: -20px;
    }
  }
  .operating {
    margin-left: 70px;
    margin-right: -19px;
    color: #666;
  }

  .color {
    color: #c5c5c5 !important;
    font-weight: normal !important;
  }
}
.pagination {
  padding-top: 25px;
  // position: fixed;
  // width: 777px;
  bottom: 0;
  text-align: right;
  height: 80px;
  background: #ffffff;
}
.button1 {
  display: inline-block;
  width: 120px;
  height: 30px;
  border-radius: 4px;
  background: #fff;
  border: 1px solid #cecece;
  text-align: center;
  cursor: pointer;
  line-height: 30px;
}
.button {
  display: inline-block;
  cursor: pointer;
  width: 98px;
  height: 30px;
  border-radius: 4px;
  background: #fff;
  margin-right: 14px;
  border: 1px solid #cecece;
  text-align: center;
  line-height: 30px;
}
.button2 {
  display: inline-block;
  width: 120px;
  height: 30px;
  border-radius: 4px;
  background: #fff;
  color: #e9ad61;
  text-align: center;
  cursor: pointer;
  line-height: 30px;
  border: 1px solid #e9ad61;
}
.revoke {
  width: 1200px;
  margin: 23px auto;
  .revoke1 {
    font-size: 18px;
    color: #333;
    font-weight: bold;
  }
  p {
    width: 600px;
    display: inline-block;
    text-align: left;
  }
  .btn {
    display: inline-block;
    width: 600px;
    text-align: right;
    font-size: 14px;
  }
}
.orderdata {
  width: 1200px;
  margin: 0 auto;
  border: 1px solid #e6e6e6;
  padding-bottom: 12px;

  .p1 {
    padding: 8px 20px;
    font-size: 14px;
    color: #999;
    border-bottom: 1px solid #e6e6e6;
    font-family: Microsoft YaHei;
  }
  .p2 {
    margin-top: 12px;
  }
  p {
    font-size: 14px;
    color: #333;
    padding: 4px 20px;
  }
}
.commodityNavigation {
  width: 1200px;
  margin: 0 auto;
  padding: 30px 0 20px;
  padding-left: 156px;
  font-size: 14px;
  color: #666;
  span:nth-child(2) {
    margin-left: 265px;
  }
  span:nth-child(3) {
    margin-left: 113px;
  }
  span:nth-child(4) {
    margin-left: 103px;
  }
  span:nth-child(5) {
    margin-left: 130px;
  }
}
.orderList {
  width: 1200px;
  margin: 0 auto;
  border: 1px solid #e6e6e6;
  position: relative;
  .image {
    position: absolute;
    width: 80px;
    height: 80px;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto;
    // z-index:;
  }
  .orderList-content {
    width: 1200px;
    height: 120px;
    padding: 12px 20px;
    border-bottom: 1px solid #e6e6e6;
    display: flex;
    align-items: center;
    // div:nth-child(2) {
    //   width: 1000px;
    // }
    .content-first {
      display: inline-block;
      // margin: 50px 0;
      vertical-align: middle;
    }
    img {
      display: inline-block;
      width: 96px;
      height: 96px;
      margin-left: 20px;
    }
    .description {
      margin-left: 10px;
      vertical-align: top;
      display: inline-block;
      width: 280px;
      font-size: 14px;
      color: #333;
      word-break: break-word;
    }
    .price {
      display: inline-block;
      vertical-align: middle;
      width: 60px;
      margin-left: 25px;
      color: #ff3939;
      font-weight: bold;
      font-family: Microsoft YaHei;
    }
    .sum {
      display: inline-block;
      margin-left: 100px;
      font-size: 14px;
      color: #333;
      width: 100px;
    }
    .price-sum {
      display: inline-block;
      margin-left: 80px;
      font-size: 14px;
      color: #333;
      max-width: 100px;
    }
    .note {
      resize: none;
      margin-left: 120px;
      width: 180px;
      vertical-align: middle;
      height: 48px;
      background: #ffffff;
      border: 1px solid #e6e6e6;
      opacity: 1;
      padding: 5px;

      overflow: overlay;
    }
  }
}
.aaa {
  height: 80px;
}
.end {
  margin: auto;
  left: 0;
  bottom: 0;
  right: 0;
  position: fixed;
  margin: 0 auto;
  margin-top: 20px;
  padding: 6px 50px 5px;
  width: 1200px;
  height: 80px;
  background: #f6f6f6;
  border: 1px solid #e6e6e6;
  font-size: 12px;
  text-align: right;
  .total {
    color: #999;
    margin-right: 30px;
    margin-top: 5px;
    span {
      margin-left: 5px;
    }
  }
  .end-content {
    margin-top: 7px;
    font-size: 16px;
    font-weight: bold;
    .span1 {
      margin-right: 74px;
    }
    .span-money {
      color: #ff3939;
    }
  }
}
.ordername {
  width: 125px;
  display: inline-block;
  text-align: right;
}
</style>
